import { fetchCartData } from "../helpers/cart";

class AnnouncementBar extends HTMLElement {
  private totalPrice: number = 0;

  constructor() {
    super();
  }

  connectedCallback(): void {
    this.getCartValue();
    document.addEventListener("cart:updated", this.getCartValue.bind(this));
  }

  disconnectedCallback(): void {
    document.removeEventListener("cart:updated", this.getCartValue.bind(this));
  }

  async getCartValue() {
    const cartData = await fetchCartData();
    this.totalPrice = cartData.total_price ?? 0;

    this.handleCartUpdate();
  }

  private handleCartUpdate(): void {
    const freeShippingIndicator = this.querySelector(
      "uwp-free-shipping-indicator",
    );

    if (!freeShippingIndicator) {
      return;
    }

    if (freeShippingIndicator) {
      freeShippingIndicator.setAttribute(
        "cart-value",
        this.totalPrice.toString(),
      );
    }

    const thresholdMet = freeShippingIndicator.getAttribute("threshold-met");
    const isIndicatorHidden = localStorage.getItem(
      "free-shipping-indicator-hidden",
    );

    if (thresholdMet === "true" && isIndicatorHidden === "true") {
      return;
    }

    if (thresholdMet !== "true") {
      localStorage.setItem("free-shipping-indicator-hidden", "false");
    }

    if (this.totalPrice > 0) {
      this.classList.add("announcement-bar--products-added");

      this.handleFreeShippingIndicatorDismissal(thresholdMet);
    } else {
      this.classList.remove("announcement-bar--products-added");
    }

    document.dispatchEvent(new CustomEvent("announcement-bar:updated"));
  }

  private handleFreeShippingIndicatorDismissal(
    thresholdMet: string | null,
  ): void {
    if (thresholdMet !== "true") {
      return;
    }

    const hideIndicatorThresholdMet = this.getAttribute(
      "settings-hide-indicator-threshold-met",
    );
    const indicatorHideTiming = this.getAttribute(
      "settings-indicator-hide-timing",
    );

    if (hideIndicatorThresholdMet !== "true" || !indicatorHideTiming) {
      return;
    }

    const formattedTiming = Number(indicatorHideTiming) * 1000;

    setTimeout(() => {
      this.classList.remove("announcement-bar--products-added");
      localStorage.setItem("free-shipping-indicator-hidden", "true");
    }, formattedTiming);
  }
}

customElements.define("uwp-announcement-bar", AnnouncementBar);
